import { render, staticRenderFns } from "./TemplateDetailsSummary.vue?vue&type=template&id=c0c6fb36&scoped=true&"
import script from "./TemplateDetailsSummary.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailsSummary.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetailsSummary.vue?vue&type=style&index=0&id=c0c6fb36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c6fb36",
  null
  
)

export default component.exports